import {JSX, ReactNode} from "react";

import {ContainerBase} from "@/shared/ui/layout/container-base";

import "./styles/trip-detail-layout.scss";

export interface TripDetailLayoutProps {
    sidebar: ReactNode;
    children: ReactNode;
    headerAction?: ReactNode;
}

export function TripDetailLayout({sidebar, children, headerAction}: TripDetailLayoutProps): JSX.Element {
    return (
        <ContainerBase>
            {headerAction && <div className="trip-detail-layout__header">{headerAction}</div>}
            <div className="trip-detail-layout">
                <aside className="trip-detail-layout__sidebar">{sidebar}</aside>
                <div className="trip-detail-layout__content">{children}</div>
            </div>
        </ContainerBase>
    );
}
